<wiz-hgroup width="100%" height="100%" style="padding: 5px;">
  <wiz-hgroup width="190px" verticalAlign="center">
    <wiz-icon class="image-white" (click)="preShowBurger()">menu</wiz-icon> <!--[visible]="moreThanYouThink()" -->
    <wiz-image [source]="LOGO_ME" width="150px" height="40px" (click)="goToAccount()" style="cursor: pointer;"></wiz-image>    
  </wiz-hgroup>
  
  <wiz-hgroup width="100%" verticalAlign="center" style="overflow-x: auto;">
    <ng-container #containerFilter style="padding: 5px;"></ng-container>
    <ng-container #btnContainerConditional></ng-container>
  </wiz-hgroup>

  <wiz-hgroup width="80px" horizontalAlign="end" verticalAlign="center" gap="10">
    <wiz-icon class="image-white" (click)="goUser()" [wizTooltip]="setUser()" tooltipPlacement="left">profile</wiz-icon>
    <wiz-icon class="image-back-orange" (click)="askForLogout()" [wizTooltip]="'$.common.log-out.$'" tooltipPlacement="left">log-out</wiz-icon>
  </wiz-hgroup>

</wiz-hgroup>
